__turbopack_context__.v({
  "flexGrid": "styles-module__2ZlSXq__flexGrid",
});
